import { useMemo } from 'react';
import { FeaturePreset, HeaderFeature } from 'src/widgets/header';

export const useCatalogHeaderConfig = (): FeaturePreset => {
  return useMemo(
    () => ({
      desktopFeatures: { [HeaderFeature.CitySelection]: true },
      mobileFeatures: { [HeaderFeature.GoBack]: true },
    }),
    [],
  );
};
